import React, {
    ReactElement,
} from 'react';
import PageTemplate from 'page_template';
import HeaderCard from 'components/header_card';
import Button from 'components/button';
import {
    Container,
    Inner,
} from './styles/service_page.style';
import {
    Heading,
    Content,
    ListSx,
    OrderedListSx,
    ListItemSx,
    SubmitServiceText,
    SubmitServiceContainer,
    ContainerSx
} from "./styles/landing_page.style";
import * as PATHS from 'routing/paths';


export default function LandingPage() {
    return (
        <PageTemplate active="service">
            <HeaderCard bkgSrc="/images/headers/student_center.png">
                <HeaderCard.Title>Community Service</HeaderCard.Title>
            </HeaderCard>
            <ContainerSx>
                {/* <Inner> */}
                <LandingPage.SubmitServiceButton>
                    SUBMIT HOURS
                </LandingPage.SubmitServiceButton>
                <Content>
                    In order to graduate with an Honors degree, every Honors student must complete a 
                    minimum number of service hours. For students in classes graduating in 2025, 
                    2026, or 2027, that is equivalent to five hours per semester in the Honors Program
                    (so, 40 hours for four years in the program, 30 hours for three years in the 
                    program, etc). For students in classes graduating in 2028 and after, that is 
                    equivalent to six hours per semester in the Honors Program (so, 48 hours for four
                    years in the program, 36 hours for three years in the program, etc.). In order to
                    ensure that progress is made towards completing this requirement, students must 
                    complete at least 25 of their required hours by the last day of classes of the 
                    fall semester of their junior academic year. These hours must be completed between 
                    the student’s enrollment in the Honors Program and the end of his/her last academic 
                    year prior to graduation. If a student does not complete the requirement before 
                    graduation, an Honors Program degree will not be granted. Appeals regarding 
                    interpretation of the service guidelines may be made in writing to the Steering 
                    Committee.
                </Content>
                <Heading>Goals of Service</Heading>
                <ListSx>
                    <ListItemSx>Directly benefits members of the community by fulfilling needs within the community</ListItemSx>
                    <ListItemSx>Develops ties between Clarkson University and the surrounding communities</ListItemSx>
                    <ListItemSx>Builds a sense of community within the Honors Program</ListItemSx>
                    <ListItemSx>Provides an opportunity for Honors students to broaden their range of life experiences</ListItemSx>
                </ListSx>
                <Heading>Kinds of Service</Heading>
                <Content>
                    These are examples of common types of service:
                </Content>
                <OrderedListSx>
                    <ListItemSx>Service performed in HP 200</ListItemSx>
                    <ListItemSx>Events planned and/or advertised by the service committee (i.e. if sent out in an email from a service representative)</ListItemSx>
                    <ListItemSx>Individual service projects proposed by an Honors student and approved by the service committee</ListItemSx>
                    <ListItemSx>Service to the Honors Program, planned by the Honors office (Open House, overnights, etc.)</ListItemSx>
                    <ListItemSx>Service to Clarkson community projects such as the Clarkson Food Pantry</ListItemSx>
                </OrderedListSx>
                <Heading>Conditions for Service</Heading>
                <ListSx>
                    <ListItemSx>At least half of the service hours must be performed while the student is at Clarkson.</ListItemSx>
                    <ListItemSx>Each act of service must uniquely fulfill the Honors Program requirement and no other. Service required for other organizations may not count as Honors service</ListItemSx>
                    <ListItemSx>Students receive credit for the actual duration of an event, not for the planned duration of an event. If an event that was supposed to last 2 hours only lasts 15 minutes, then only 15 minutes is counted.</ListItemSx>
                    <ListItemSx>The service activity must not express political commentary or otherwise render an opinion for or against a community issue (no protesting). The event may encourage political discussion, while remaining neutral.</ListItemSx>
                </ListSx>
                {/* </Inner> */}
            </ContainerSx>
        </PageTemplate>
    );
}

LandingPage.SubmitServiceButton = function LandingPageSubmitServiceButton({ children, ...otherProps }) {
    return (
        <SubmitServiceContainer>
            <Button variant="contained" border="rounded" {...otherProps}>
                <SubmitServiceText to={PATHS.SERVICE + '/submit'} state={{ from: location.pathname }}>{children}</SubmitServiceText>
            </Button>
        </SubmitServiceContainer>
    );
}
